var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/localization.j2"] = require( "macros/localization.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-title.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/localization.j2", false, "category/templates/category-title.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("generate_localization_slug_for_nav_item")) {
var t_4 = t_1.generate_localization_slug_for_nav_item;
} else {
cb(new Error("cannot import 'generate_localization_slug_for_nav_item'")); return;
}
context.setVariable("slug", t_4);
if(t_1.hasOwnProperty("localized_slug_for_flat_nav_slug")) {
var t_5 = t_1.localized_slug_for_flat_nav_slug;
} else {
cb(new Error("cannot import 'localized_slug_for_flat_nav_slug'")); return;
}
context.setVariable("localized_slug_for_flat_nav_slug", t_5);
var t_6;
t_6 = (lineno = 1, colno = 21, runtime.callWrap(t_4, "slug", context, [runtime.contextOrFrameLookup(context, frame, "navItem"),"category_seo","title"]));
frame.set("titleSlug", t_6, true);
if(frame.topLevel) {
context.setVariable("titleSlug", t_6);
}
if(frame.topLevel) {
context.addExport("titleSlug", t_6);
}
var t_7;
t_7 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isBrand")?(lineno = 2, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"brandNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug")),"displayName"])):runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"crawlableMetaData")),"titleText"));
frame.set("crawlableMetaTitle", t_7, true);
if(frame.topLevel) {
context.setVariable("crawlableMetaTitle", t_7);
}
if(frame.topLevel) {
context.addExport("crawlableMetaTitle", t_7);
}
output += "\n<title class=\"js-category-title-component\">\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"hasH1Override")) {
var t_8;
t_8 = "category_h1-wrapper_" + "" + runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"crawlableMetaData")),"key");
frame.set("localization_key", t_8, true);
if(frame.topLevel) {
context.setVariable("localization_key", t_8);
}
if(frame.topLevel) {
context.addExport("localization_key", t_8);
}
output += "\n    ";
var t_9;
t_9 = (lineno = 8, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "localization_key"),runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"crawlableMetaData")),"refinement")),"value"),runtime.contextOrFrameLookup(context, frame, "crawlableMetaTitle")]})]));
frame.set("titleTextOverride", t_9, true);
if(frame.topLevel) {
context.setVariable("titleTextOverride", t_9);
}
if(frame.topLevel) {
context.addExport("titleTextOverride", t_9);
}
output += "\n    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 9, colno = 6, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "titleSlug"),runtime.makeKeywordArgs({"params": [env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "titleTextOverride")),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"siteName")]})]))), env.opts.autoescape);
;
}
else {
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 11, colno = 6, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "titleSlug"),runtime.makeKeywordArgs({"params": [env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "crawlableMetaTitle")),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"siteName")]})]))), env.opts.autoescape);
;
}
output += "</title>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-title.j2"] , dependencies)